import React, { ReactElement } from 'react';
import { Input as AntDesignInput, InputProps } from 'antd';
import _ from 'lodash';

export default function Input(props: InputProps): ReactElement {
    const {
        showCount,
        maxLength,
        value,
        ...otherProps
    } = props;

    const dataCount: string = showCount && (
        maxLength
            ? `${_.toString(value).length} / ${maxLength}`
            : `${_.toString(value).length}`
    );

    return (
        <div
            className='funding-input'
            data-count={dataCount}
        >
            <AntDesignInput
                maxLength={maxLength}
                value={value}
                {...otherProps}
            />
        </div>
    );
};